import React, {useState, useEffect} from 'react';
import {Link, generatePath} from 'react-router-dom';
import ContactBlock from './contactBlock';
import routes from 'globals/routes';
import {useDataValue} from 'globals/contexts/dataContext';
import {useHistory} from "react-router-dom";
import './menu.css';
const Menu = () => {
  const [isActive, setIsActive] = useState(false);
  const [{content, currentLanguage, currentPage}, dispatch] = useDataValue();
  const history = useHistory();
  const allLanguage = content['language'];
  const logoUrl = content['logo'];
  const currentLanguageIndex = allLanguage.findIndex(lang => lang.code === currentLanguage);
  // const currentLanguageItem = allLanguage[currentLanguageIndex];
  const nextLanguage = allLanguage[(currentLanguageIndex + 1) % allLanguage.length];
  // console.log(nextLanguage);
  const menuContent = content['content'][currentLanguage]['menu'];
  const toggleIsActive = () => {  
    setIsActive(!isActive);
  }
  const navigateToPage = (page) => {
    setIsActive(false);
    setTimeout(() => 
      history.push(routes.pageWithLang(page, currentLanguage))
    );
      // to={routes.pageWithLang(item['to'], currentLanguage)}
  }
  useEffect(() => {
    dispatch({
      type: 'setMenuIsActive',
      data: isActive
    });
  }, [isActive]);

  const switcherOnClick = () => {
    
    dispatch({
      type: 'pageTransitionStart',
    });
    setTimeout(() => {
      const nextPage = currentPage? (!currentPage.startsWith("commercial")? "commercial": "index") : "commercial";
      history.push(routes.pageWithLang(nextPage, currentLanguage));
      dispatch({
        type: 'toggleActiveContent',
      });
    }, 1500);
  }

  return (
    <div id="menu">
      <div className="logo">
        <Link to={generatePath(routes.indexPage, {lang: currentLanguage})}>
          <img src={logoUrl} />
        </Link>
      </div>
      <div className="menuButton" onClick={toggleIsActive}></div>
      <div className="quickNavigation verticalText">
        {/* <Link to={routes.pageWithLang('index', currentLanguage)}>Index</Link> */}
        <Link to={generatePath(routes.aboutPage, {lang: currentLanguage})}>About</Link>
        <Link to={generatePath(routes.artPage, {lang: currentLanguage})}>Work</Link>

        {/* <Link to={routes.pageWithLang('test', currentLanguage)}>Test</Link> */}
        <div className="seperator" />
        <Link to={routes.pageWithLang(currentPage, nextLanguage['code'])}>{nextLanguage.display}</Link>
      </div>
      <div className="languageSelect verticalText">
        <div className="label">{currentLanguage === 'tc'? '選擇語言': 'Select Language'}</div>
        {allLanguage.map(langItem => {
          return <Link
            key={langItem['code']}
            className={langItem['code'] === currentLanguage? 'current': ''}
            to={routes.pageWithLang(currentPage, langItem['code'])}
          >
            {langItem["display"]}
          </Link>;
        })}
      </div>
      <div className="pen"><img src="./media/pen.png" /></div>
      <div className="inkStone"><img src="./media/inkStone.png" /></div>
      <div className="menuItems">
        {menuContent['items'].map((item, idx) => {
          return <Link key={idx} to={generatePath(routes[item['to']], { lang: currentLanguage })}>
            <div className="textWrapper">
              <div className="hoverText">{item['label']}</div>
              <div className="normalText">{item['label']}</div>
            </div>
          </Link>
        })}
      </div>
      <a className="switcher" onClick={switcherOnClick}>
        {currentLanguage === "en" ? 
          <div className="label">Selected<br/>{!currentPage || currentPage.startsWith("commercial")? "Art": "Commercial"} Work</div>
        :
          <div className="label">
            {!currentPage || currentPage.startsWith("commercial")? "書法": "商業"}
            作品集
          </div>
        }
      </a>
      <ContactBlock />
    </div>
  );
}

export default Menu;